/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_Erp_Dates_HintInputs */



/**
* | output |
* | --- |
* | "A bill is in the file when its last service day falls between these two days." |
*
* @param {Admin_Export_Erp_Dates_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_erp_dates_hint = /** @type {((inputs?: Admin_Export_Erp_Dates_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Erp_Dates_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Rechnung ist in der Datei, wenn ihr letzter Leistungstag zwischen diesen beiden Tagen liegt.")
	return /** @type {LocalizedString} */ ("A bill is in the file when its last service day falls between these two days.")
});